import { useEffect, useState, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { startLive } from '../../services/cameraService';
import '../../vendor/go2rtc-video-stream'; // registers <video-stream>

export function toWsUrl(playUrl) {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  // playUrl is a proxied absolute path like /live/api/ws?src=cam-c1
  return `${proto}//${window.location.host}${playUrl}`;
}

export default function LivePlayer({ cameraId }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  const connect = useCallback(() => {
    setError(false); setSrc(null);
    startLive(cameraId)
      .then((d) => setSrc(toWsUrl(d.playUrl)))
      .catch(() => setError(true));
  }, [cameraId]);

  useEffect(() => { connect(); }, [connect]);

  if (error) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography color="text.secondary" gutterBottom>Camera offline</Typography>
        <Button variant="outlined" onClick={connect}>Retry</Button>
      </Box>
    );
  }
  if (!src) return <Typography variant="caption">Connecting…</Typography>;
  // <video-stream> (go2rtc) negotiates WebRTC, falling back to MSE automatically.
  return <video-stream src={src} style={{ width: '100%', background: '#000' }} />;
}
